
<div class="nav-container-2 view-container">
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pl-3 pr-3">
      <div *ngIf="selectedTab==false">
        <mat-tab-group>
          <mat-tab label=""></mat-tab>
          <mat-tab>
              <ng-template mat-tab-label>
                Peer Review No :  {{reviewList.review_No}}
                  <i class="fa fa-times-circle ml-3" aria-hidden="true" (click)="closeViewTab(tab)"></i>
              </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div> 
  </div>
</div>

<div class="" *ngIf="selectedTab==true">
  <div class="outlet_container">
    <div class="row">
      <div class="col-12">
        <kendo-grid [kendoGridBinding]="mainList" [filterable]="enableFilter" [pageSize]="20" [pageable]="true" [sortable]="true">

          <ng-template kendoPagerTemplate>
            <div class="k-pager-left">
              <kendo-pager-info></kendo-pager-info>
            </div>
            <div class="k-pager-right">
              <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
              <kendo-pager-input></kendo-pager-input>
              <kendo-pager-next-buttons></kendo-pager-next-buttons>
            </div>
          </ng-template>
          
          <ng-template kendoGridToolbarTemplate>
            <div class="k-grid-toolbar-content d-flex">
            </div>
          </ng-template>

          <kendo-grid-column title="Req No" width="90" field="review_No">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              <span class="eip-link" (click)="viewPeerdoc(dataItem)">
                {{dataItem.review_No}}
              </span>
            </ng-template>
            <!-- <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              {{dataItem.review_No}}
            </ng-template> -->
          </kendo-grid-column>
    
          <kendo-grid-column title="Discipline" field="ded_Desc" width="80">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              {{dataItem.deD_Desc}}
            </ng-template>
          </kendo-grid-column>
    
          <kendo-grid-column title="Request Status" field="req_Status" width="80">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              {{dataItem.req_Status}}
            </ng-template>
          </kendo-grid-column>
    
          <kendo-grid-column title="Created By" field="created_By" width="80">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              {{dataItem.created_By}}
            </ng-template>
          </kendo-grid-column>
  
          <kendo-grid-column title="Created On" field="created_On" width="60">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              {{dataItem.created_On | date:'dd-MMM-yyyy'}}
            </ng-template>
          </kendo-grid-column>
    
          <kendo-grid-column title="Date & Time of Review" width="115">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              {{dataItem.date | date:'dd-MMM-yyyy'}}
              {{dataItem.time_From | date:'h:mm:ss a'}} -
              {{dataItem.time_To | date:'h:mm:ss a'}}
            </ng-template>
          </kendo-grid-column>
    
          <kendo-grid-column title="Document Location" width="80" field="doc_Location">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              {{dataItem.doc_Location}}
            </ng-template>
          </kendo-grid-column>
      
          <kendo-grid-column title="Approved By" field="approved_By" width="80">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              {{dataItem.approved_By}}
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column title="Approved On" field="approved_On" width="60">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              {{dataItem.approved_On | date:'dd-MMM-yyyy'}}
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column title="Comments Submitted Status" width="50">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              <div *ngIf="dataItem.dS_Code=='32'||dataItem.dS_Code=='33'||dataItem.dS_Code=='34'||dataItem.dS_Code=='36'; else not">
                Yes
              </div>
            </ng-template>
            <ng-template #not>
              No
            </ng-template>
          </kendo-grid-column>
    
          <kendo-grid-column title="Actions" width="30">
            <ng-template kendoGridCellTemplate let-rowIndex="rowIndex" let-dataItem="dataItem">
              <i class="fa fa-pencil" aria-hidden="true" (click)="viewDocumentClick(dataItem)"></i>
            </ng-template>
          </kendo-grid-column>


        </kendo-grid>
      </div>
    </div>
  </div>
</div>

<div *ngIf="selectedTab==false">
  <app-add-response [Data]="reviewList"></app-add-response>
</div> 
